import 'react-perfect-scrollbar/dist/css/styles.css';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import GlobalStyles from 'src/components/GlobalStyles';
import goodalipi from 'src/plugins/goodalipi';
import theme from 'src/theme';
import routes from 'src/routes';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useAxiosLoader } from './plugins/axios';
import { InitAnalytics } from '@docsapp/analytics';
import ClevertapReact from 'clevertap-react';
import { useSnowplowAnalytics } from './hooks/useSnowplowAnalytics';
import { useEffect, useRef } from 'react';
import { sendAnalyticsEvents } from './analytics/snowplow';
import { SNOWPLOW_EVENTS_NAME, EVENT_KEYS, PLATFORM_WEB } from './analytics/constants';

ClevertapReact.initialize('649-47W-Z55Z');

const App = () => {
  const isLoggedIn = goodalipi.get('user');
  const isMinor = goodalipi.get('isMinor') === "isBooleantrue";
  const routing = useRoutes(routes(isLoggedIn, isMinor));
  const [loading] = useAxiosLoader();
  const { snowplowScript, isSnowplowReady } = useSnowplowAnalytics();
  const hasTrackedPageOpen = useRef(false);
  const hasInitializedAnalytics = useRef(false);

  useEffect(() => {
    if (isSnowplowReady && !hasTrackedPageOpen.current) {
      hasTrackedPageOpen.current = true;
      sendAnalyticsEvents(SNOWPLOW_EVENTS_NAME.HRWIN_PAGE_OPEN, {
        [EVENT_KEYS.PLATFORM]: PLATFORM_WEB,
      });
    }
  }, [isSnowplowReady]);

  return (
    <>
      {snowplowScript && <InitAnalytics snowplowJS={snowplowScript} />}
      <ThemeProvider theme={theme}>
        <Backdrop
          sx={(theme) => ({
            zIndex: `${theme.zIndex.drawer + 1} !important`,
            color: '#fff',
          })}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <GlobalStyles />
        {routing}
      </ThemeProvider>
    </>
  );
};

export default App;
